export const questions = [
  {
    id: 1,
    question: "What is the importance of React in modern world",
    answer:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Veritatis nesciunt illo id rem dolore repellendus",
  },
  {
    id: 2,
    question: "What is the importance of React in modern world",
    answer:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Veritatis nesciunt illo id rem dolore repellendus",
  },
  {
    id: 3,
    question: "What is the importance of React in modern world",
    answer:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Veritatis nesciunt illo id rem dolore repellendus",
  },
  {
    id: 4,
    question: "What is the importance of React in modern world",
    answer:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Veritatis nesciunt illo id rem dolore repellendus",
  },
  {
    id: 5,
    question: "What is the importance of React in modern world",
    answer:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Veritatis nesciunt illo id rem dolore repellendus",
  }
 
];
